export enum RouterUriComponents {
  INVOICING_MAIN_PAGE = 'invoicing',
  INVOICING_RESEND_PAGE = 'resend-invoice',
  NOT_AUTHORIZED_PAGE = 'not-authorized',
  RELEASE_INVOICE = 'release-invoice',
  RFC_MANAGEMENT = 'rfc-management',
}
